<div class="content-wrapper container-xxl p-0">
    <div class="content-body pt-4 pl-4 pr-4 pb-2">
        <app-order-event></app-order-event>

        <!-- contact us -->
        <app-contact></app-contact>
        <!--/ contact us -->
    </div>
</div>